// src/components/HotjarScript.js
import React, { useEffect } from 'react';

/**
 * Hotjar Tracking Script Component
 * Loads Hotjar analytics for user behavior tracking
 * Site ID: 5252549
 */
const HotjarScript = ({ siteId = 5252549, version = 6 }) => {
  useEffect(() => {
    // Hotjar is already loaded in index.html, but we ensure it's initialized
    if (typeof window !== 'undefined' && window.hj) {
      // Hotjar is already available
      return;
    }

    // Fallback: Load Hotjar if not already in page
    if (typeof window !== 'undefined' && !window.hj) {
      (function(h, o, t, j, a, r) {
        h.hj = h.hj || function() { (h.hj.q = h.hj.q || []).push(arguments); };
        h._hjSettings = { hjid: siteId, hjsv: version };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
  }, [siteId, version]);

  return null;
};

export default HotjarScript;
